// SA cellphone helpers — kept in sync with backend `normalize_sa_cell`.

// Strip anything that isn't a digit, space, or a single leading "+".
export const sanitizeCell = (value) =>
  (value || '').replace(/[^\d+\s]/g, '').replace(/(?!^)\+/g, '');

// Normalise to canonical SA form 0XXXXXXXXX, or null if not interpretable.
// Mirrors backend `normalize_sa_cell`.
export const normalizeSACell = (raw) => {
  let digits = (raw || '').replace(/\D/g, '');
  if (!digits) return null;
  if (digits.startsWith('27') && digits.length === 11) digits = '0' + digits.slice(2);
  else if (digits.length === 9) digits = '0' + digits;
  return digits.length === 10 && digits.startsWith('0') && '678'.includes(digits[1]) ? digits : null;
};

// Backwards-compatible boolean check used by pages/components that haven't
// migrated to `normalizeSACell` yet.
export const isValidSACell = (raw) => normalizeSACell(raw) !== null;
